import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { SoundProvider } from "@/lib/SoundContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Nav from "@/components/Nav";
import FridgeButton from "@/components/FridgeButton";
import Home from "@/pages/Home";
import Interior from "@/pages/Interior";
import FreezerPage from "@/pages/FreezerPage";
import GoodStuffPage from "@/pages/GoodStuffPage";
import BrandsPage from "@/pages/BrandsPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Link } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.9 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function NotFound() {
  return (
    <div className="min-h-screen kitchen-bg flex flex-col items-center justify-center gap-6 pt-24 pb-10 text-center px-4">
      <p className="font-hand text-2xl">this shelf is empty.</p>
      <p className="font-display text-3xl sm:text-4xl">NOTHING TO SNACK ON</p>
      <Link to="/" className="btn-cartoon" data-testid="notfound-back-button">
        ← back to the fridge
      </Link>
    </div>
  );
}

function GlobalFridgeButton() {
  const { pathname } = useLocation();
  if (pathname === "/") return null;
  return <FridgeButton variant="close" className="fixed bottom-5 right-5 z-50" />;
}

function App() {
  return (
    <ErrorBoundary>
      <SoundProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <Nav />
          <GlobalFridgeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fridge" element={<Interior />} />
            <Route path="/freezer" element={<FreezerPage />} />
            <Route path="/frankenstein" element={<GoodStuffPage />} />
            <Route path="/brand-building" element={<BrandsPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </SoundProvider>
    </ErrorBoundary>
  );
}

export default App;